export function crearFichasAlfombra(scene) {

  // ficha10
  scene.anims.create({
    key: "fichaAlfombraValor10",
    frames: scene.anims.generateFrameNumbers("fichaAlfombra1", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha20
  scene.anims.create({
    key: "fichaAlfombraValor20",
    frames: scene.anims.generateFrameNumbers("fichaAlfombra2", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha50
  scene.anims.create({
    key: "fichaAlfombraValor50",
    frames: scene.anims.generateFrameNumbers("fichaAlfombra3", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha100
  scene.anims.create({
    key: "fichaAlfombraValor100",
    frames: scene.anims.generateFrameNumbers("fichaAlfombra4", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha500
  scene.anims.create({
    key: "fichaAlfombraDorada",
    frames: scene.anims.generateFrameNumbers("fichaAlfombra5", {
      start: 0,
      end: 3,
    }),
    frameRate: 10,
    repeat: -1,
  });
}
